export default function Hero() {
  return (
    <section className="relative w-full h-screen min-h-[640px] overflow-hidden">
      {/* Background video */}
      <video
        src="https://public.readdy.ai/ai/video_res/019ece81-999e-71e3-8b2f-6c58f2f00845.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Top navigation bar (sits over hero) */}
      <nav className="relative z-20 w-full flex items-center justify-between px-6 md:px-12 lg:px-16 py-6">
        <a href="/" className="text-neutral-900 font-serif text-2xl tracking-wide">
          Auréa
        </a>
        <ul className="hidden md:flex items-center gap-9 text-neutral-700 text-sm tracking-wide">
          <li><a href="#collection" className="hover:text-neutral-900 transition-colors">Collection</a></li>
          <li><a href="#atelier" className="hover:text-neutral-900 transition-colors">Atelier</a></li>
          <li><a href="#journal" className="hover:text-neutral-900 transition-colors">Journal</a></li>
          <li><a href="#contact" className="hover:text-neutral-900 transition-colors">Contact</a></li>
        </ul>
        <div className="hidden md:flex items-center gap-5">
          <a
            href="#book"
            className="text-sm text-neutral-900 border border-neutral-900/40 hover:bg-neutral-900 hover:text-white transition-colors px-5 py-2 rounded-full tracking-wide cursor-pointer whitespace-nowrap"
          >
            Book a Viewing
          </a>
        </div>
        <button className="md:hidden text-neutral-900 w-10 h-10 flex items-center justify-center cursor-pointer">
          <i className="ri-menu-line text-2xl"></i>
        </button>
      </nav>

      {/* Hero text — upper left */}
      <div className="font-modern relative z-10 px-6 md:px-12 lg:px-16 pt-6 md:pt-10 max-w-3xl">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-neutral-900/60"></span>
          <span className="text-neutral-700 text-xs tracking-[0.35em] uppercase font-medium">
            Maison Auréa · Est. 1962
          </span>
        </div>

        <h1 className="text-neutral-900 text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight font-bold">
          The Quiet Luxury <br />
          of <span className="font-display italic font-light text-neutral-800 tracking-normal">Liquid Gold</span>.
        </h1>

        <p className="mt-8 text-neutral-600 text-base md:text-lg leading-relaxed max-w-md font-normal">
          Hand-poured silks and molten metallic finishes, shaped by our
          Parisian atelier. Autumn 2026 — an edition of twenty-four.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <a
            href="#collection"
            className="inline-flex items-center gap-3 bg-neutral-900 text-white px-7 py-3.5 rounded-full text-sm tracking-[0.15em] uppercase hover:bg-neutral-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Explore the Collection
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="#film"
            className="inline-flex items-center gap-3 text-neutral-900 text-sm tracking-[0.15em] uppercase group cursor-pointer whitespace-nowrap"
          >
            <span className="w-10 h-10 rounded-full border border-neutral-900/50 flex items-center justify-center group-hover:bg-neutral-900/10 transition-colors">
              <i className="ri-play-fill text-base"></i>
            </span>
            Watch the Film
          </a>
        </div>
      </div>
    </section>
  );
}